import { ColumnType } from "../components/PhasePlan/Column";
import { TagType } from "./ TagType";

export enum  ConstraintStatus {
    Todo='Todo',
    WorkingOn='Working On',
    Done='Done',
    DoneDone='Done Done'
}

export type Constraint = {
    uid?: string,
    dateCreated: number;
    identifyBy: string;
    assignedTo: string;
    description: string;
    dueByDate: number;
    tagId: string;
    tagType: ColumnType;
    status: ConstraintStatus;
    tagCardType?: TagType
    indexId: number
};


// WEBPACK FOOTER //
// ./src/models/Constraint.ts